import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { FcpButtonModule, FcpDropdownModule, FcpIconModule, FcpIconModuleSVG } from 'fc-ui-components';

import { SignupRequestComponent } from './signup-request.component';
import { ResponsiveWrapperModule } from 'src/app/components/responsive-wrapper/responsive-wrapper.module';
import { NavigationBlockerLayoutModule } from 'app/authentication/components/navigation-blocker-layout/navigation-blocker-layout.module';

@NgModule({
    declarations: [SignupRequestComponent],
    imports: [
        CommonModule,
        NavigationBlockerLayoutModule,
        TranslateModule,
        FcpDropdownModule,
        FcpIconModule,
        ResponsiveWrapperModule,
        FcpButtonModule,
        RouterModule,
        ReactiveFormsModule,
        FcpIconModuleSVG
    ]
})
export class SignupRequestModule {}
